import PerfectScrollbar from "perfect-scrollbar"

export function psConfig() {
    const browserType = document.querySelector('body.browser-firefox')

    const configSpecific = {
        "firefox" : {
            wheelPropagation: true,
            swipeEasing:true,
        },
        "other" : {
            wheelSpeed: 0.25,
            wheelPropagation: true,
            swipeEasing:true,
        }
    }

    return browserType != null ? configSpecific['firefox'] : configSpecific['other'];
}

export default function PerfectScrollbarCom(app, $context = null) {

    if(!$context) $context = $('body.is-desktop:not(.internet-explorer):not(.macintosh)')

    $context.find('.ps-scrollbar').each(function(index, value) {
        const ps = new PerfectScrollbar(value, psConfig())
        $(window).resize(function(){ ps.update() })
        app.events.on('kx_psUpdate', function () { ps.update() })
    })

}
